import axios from "axios"

export const NetsisApi = {
    async CustomerAccount(data){
        const response = await axios.post('/api/netsis/table/customeraccounts',data)
        return response
    },
    async CustomerAccountPaginationTable(data){
        const response = await axios.post('/api/netsis/paginatetable/customeraccounts',data)
        return response
    },
    async SendExtre(cariCode, mail) {
        const c = encodeURIComponent(cariCode)
        const m = encodeURIComponent(mail)
        return axios.get(`/api/netsis/send/ekstre/${c}/${m}`)
    },
    async CustomerAccountAction(data){
        const response = await axios.post('/api/netsis/table/customeraccountactions',data)
        return response
    },
    async CustomerAccountActionStats(data){
        const response = await axios.get(`/api/netsis/stats/customeraccountactions/${encodeURIComponent(data)}`)
        return response
    },
    async CustomerContact(data){
        const response = await axios.post('/api/netsis/createorupdate/customercontact',data)
        return response
    },
    async CanBeInstallmentWithoutApprove(){
        const response = await axios.get('/api/netsis/get/canbeinstallmentwithoutapprovedata')
        return response
    },
    async GetLastInstallmentDayInvoices(){
        const response = await axios.get('/api/netsis/get/lastinstallmentdayinvoices')
        return response
    },
    async FaturaDetay(cariCode, documentNo) {
        return axios.get(`/api/netsis/faturadetayi/${encodeURIComponent(cariCode)}/${encodeURIComponent(documentNo)}`)
    },
    async FaturaDetayGonder(email, cariCode, documentNo) {
        return axios.post(`/api/netsis/send/faturdetayi/link/${encodeURIComponent(email)}/${encodeURIComponent(cariCode)}/${encodeURIComponent(documentNo)}`)
    },
    async FaturaDetayIcerikFromNetsis(cariCode, documentNo) {
        return axios.get(`/api/netsis/get/faturadetayi/${encodeURIComponent(cariCode)}/${encodeURIComponent(documentNo)}`)
    },
    async GetTaksitYapilabilirOdemelerReportExcel() {
        const response = await axios.get(`/api/netsis/get/taksityapilabilirodemeler/excel`);
        return response;
    },
    async customerAccountActionForCustomer(data){
        const response = await axios.post('/api/netsis/table/customeraccountactionsforcustomer', data)
        return response
    },
    async customerAccountActionStatsForCustomer(cariCode) {
        return axios.get(`/api/netsis/stats/customeraccountactionsforcustomer/${encodeURIComponent(cariCode)}`)
    },
    async SendDeliveryCode(customerCode, belgeNo) {
        return axios.post('/api/netsis/send/delivery-code', { CustomerCode: customerCode, BelgeNo: belgeNo })
    },
    async VerifyDeliveryCode(customerCode, belgeNo, code) {
        return axios.post('/api/netsis/verify/delivery-code', { CustomerCode: customerCode, BelgeNo: belgeNo, Code: code })
    },
    async GetCustomerDeliveryPhone(customerCode) {
        return axios.get(`/api/netsis/get/customer-delivery-phone/${encodeURIComponent(customerCode)}`)
    },
}